const teamRoleType = {
	LEAD: "LEAD",
	MEMBER: "MEMBER",
	MANAGER: "MANAGER",
	REPORT: "REPORT",
	PEER: "PEER",
};

export default Object.freeze( teamRoleType );



// WEBPACK FOOTER //
// ./src/constants/TeamRoleType.js